import React, { useEffect, useState, useRef } from 'react';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
const STORAGE_KEY = 'twm-announcement-forms-dismissed-v1';
// Custom event so other components (e.g. Navbar) can react to changes
const EVENT_NAME = 'twm-announcement-change';
function setAnnouncementHeight(height: number) {
  document.documentElement.style.setProperty('--announcement-height', `${height}px`);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, {
    detail: {
      height
    }
  }));
}
export function AnnouncementBar() {
  const [dismissed, setDismissed] = useState(true);
  const ref = useRef<HTMLDivElement | null>(null);
  // Initialize visibility from sessionStorage
  useEffect(() => {
    const isDismissed = sessionStorage.getItem(STORAGE_KEY) === 'true';
    setDismissed(isDismissed);
  }, []);
  // Keep the CSS variable in sync with the bar's real height
  useEffect(() => {
    if (dismissed) {
      setAnnouncementHeight(0);
      return;
    }
    if (!ref.current) return;
    const update = () => {
      if (ref.current) setAnnouncementHeight(ref.current.offsetHeight);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(ref.current);
    window.addEventListener('resize', update);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [dismissed]);
  const handleDismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    setDismissed(true);
  };
  if (dismissed) return null;
  return <div ref={ref} role="alert" className="fixed top-0 left-0 right-0 w-full bg-yellow-300 border-b-2 border-yellow-500 z-[70]" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 sm:py-3 flex items-start sm:items-center justify-center gap-3 sm:gap-4" data-id="element-96">
        <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-red-600 shrink-0 mt-0.5 sm:mt-0 animate-pulse" data-id="element-97" />
        <p className="text-red-600 font-bold text-xs sm:text-sm md:text-base text-center leading-snug pr-8 sm:pr-10" data-id="element-98">
          <span className="uppercase tracking-wider" data-id="element-99">Important Notice:</span>{' '}
          We're aware of an issue with our forms and are actively fixing it. Due
          to this, we have not been receiving quote requests for travel. We
          sincerely apologize for any inconvenience this has caused.
        </p>
        <button onClick={handleDismiss} aria-label="Dismiss announcement" className="absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 p-1 rounded-full text-red-600 hover:bg-yellow-400 transition-colors" data-id="element-100">
          <XIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-101" />
        </button>
      </div>
    </div>;
}
export const ANNOUNCEMENT_CHANGE_EVENT = EVENT_NAME;